import { render, staticRenderFns } from "./ImportLeadFile.vue?vue&type=template&id=5c2720e2&"
import script from "./ImportLeadFile.vue?vue&type=script&lang=js&"
export * from "./ImportLeadFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports